module.exports = __webpack_public_path__ + "img/table.fe7671a5.svg";